import { env } from '@/shared/config';

import styles from './DemoBanner.module.scss';

/**
 * Плашка демо-режима.
 *
 * Не украшение: на экране лежат выдуманные данные, и без явной пометки
 * стенд неотличим от настоящего. Ровно та же логика, что у плашки режима
 * ключа в админке.
 *
 * Плашка стоит НАД холстом `.layout` (`App.tsx`), а не внутри него —
 * `useAppScale` (widgets/app-layout) меряет её реальную высоту напрямую
 * по `data-testid`, здесь ничего специально готовить не нужно.
 */
export function DemoBanner() {
  if (!env.demo) return null;

  return (
    <div className={styles.banner} role="status" data-testid="demo-banner">
      демо-режим: данные выдуманы, бэкенд не подключён
    </div>
  );
}
